import { N0PassengerSeatRequest } from '@models/requests/passenger-seat-request';
import { N0SellKey } from '@models/requests/trip-sell-request.model';
import { N0SsrPassengerUpdateRequest } from '@models/requests/ssr-passenger-update-request.model';
import { createAction, props } from '@ngrx/store';
import {
  Seat,
  SeatMap,
  SeatMapAvailability,
} from 'src/app/models/booking.models';

export const enum SeatActionTypes {
  loadSeatMaps = '[seat] LOAD_SEATMAPS',
  setSeatMaps = '[seat] SET_SEATMAPS',
  saveSeats = '[seat] SAVE_SEATS',
  loadSeatMapsSuccess = '[seat] LOAD_SEATMAPS_SUCCESS',
  updatePassengerSeats = '[seat] UPDATE_PASSENGER_SEATS',
  updatePassengerSeatsSuccess = '[seat] UPDATE_PASSENGER_SEATS_SUCCESS',
  seatSelected = '[passenger] SEAT_SELECTED',
  seatRemoved = '[passenger] SEAT_REMOVED',
  setActiveSegment = '[seat] SET_ACTIVE_SEGMENT',
  setActivePassenger = '[seat] SET_ACTIVE_PASSENGER',
  sitTogetherSelected = '[seat] SIT_TOGETHER_SELECTED',
  initSeatMap = '[seat] INIT_SEAT_MAP',
  initUpgradeFareToPremium = '[seat] INIT_UPGRADE_FARE_TO_PREMIUM',
  initUpgradeFareToPremiumSuccess = '[seat] INIT_UPGRADE_FARE_TO_PREMIUM_SUCCESS',
  initUpgradeFareToPremiumFinish = '[seat] INIT_UPGRADE_FARE_TO_PREMIUM_FINISH',
}

export const seatLoadSeatMaps = createAction(SeatActionTypes.loadSeatMaps);

export const seatSetSeatMaps = createAction(
  SeatActionTypes.setSeatMaps,
  props<{ payload: SeatMap[] }>(),
);

export const seatSaveSeats = createAction(
  SeatActionTypes.saveSeats,
  props<{ payload: Seat }>(),
);

export const loadSeatMapsSuccess = createAction(
  SeatActionTypes.loadSeatMapsSuccess,
  props<{ seatMaps: SeatMapAvailability[] }>(),
);

export const updatePassengerSeats = createAction(
  SeatActionTypes.updatePassengerSeats,
  props<{ updates: N0PassengerSeatRequest[], redirectToPayment?: boolean, ssrs: N0SsrPassengerUpdateRequest[] }>(),
);

export const updatePassengerSeatsSuccess = createAction(
  SeatActionTypes.updatePassengerSeatsSuccess,
  props<{ redirectToPayment?: boolean }>()
);

export const passengerSeatSelected = createAction(
  SeatActionTypes.seatSelected,
  props<{
    passengerKey: string;
    journeyKey: string;
    segmentKey: string;
    seatKey: string;
    seatDisplayName: string;
  }>(),
);

export const sitTogetherSelected = createAction(
  SeatActionTypes.sitTogetherSelected, 
  props<{
    payload: N0SsrPassengerUpdateRequest
  }>(),
);

export const passengerSeatRemoved = createAction(
  SeatActionTypes.seatRemoved,
  props<{
    passengerKey: string;
    segmentKey: string;
  }>(),
);

export const setActiveSegment = createAction(
  SeatActionTypes.setActiveSegment,
  props<{
    activeSegmentKey: string;
    activePassengerKey?: string;
  }>(),
);

export const setActivePassenger = createAction(
  SeatActionTypes.setActivePassenger,
  props<{
    activePassengerKey: string;
  }>(),
);

export const initSeatMap = createAction(
  SeatActionTypes.initSeatMap,
  props<{
    activePassengerKey: string;
  }>(),
);

// UPGRADE TO PREMIUM feat-002379-seatmap-PremiumUpgrade

export const initUpgradeFareToPremium = createAction(
  SeatActionTypes.initUpgradeFareToPremium,
  props<{
    sellKeys: N0SellKey[]
  }>(),
);

export const initUpgradeFareToPremiumSuccess = createAction(
  SeatActionTypes.initUpgradeFareToPremiumSuccess
);

export const initUpgradeFareToPremiumFinish = createAction(
  SeatActionTypes.initUpgradeFareToPremiumFinish
);